module.exports = __webpack_public_path__ + "img/seller_pays_the_commission.a237d58b.webp";